import Config from "../Config/Config";
import {SHORT_SIGNUP_ANALYTICS_REFERRAL} from "shared/pages/AdminPage"

type StringOrNumber = string | number | undefined;

const SHORT_SIGNUP = "/shortsignup";
const CONNECT_BANK = "/connect/bank";
const ADMIN_APPLICATION_ID_QUERY_PARAM = "id";
const ADMIN_COWORK_ID_QUERY_PARAMS = "cowork";
const HTTPS_PREFIX = "https://";


export default class Utils {
  public static guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      s4() +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      s4() +
      s4()
    );
  }

  public static capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  public static removeUndefinedKeys(obj: object) {
    Object.keys(obj).forEach(key => {
      if (typeof obj[key] === 'object') {
        this.removeUndefinedKeys(obj[key])
      }
      if (obj[key] === undefined) {
        delete obj[key];
      }
    });
  }

  public static numberWithCommas = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  public static prettyCurrencyNumber = (num: number) =>
    `$${Utils.numberWithCommas(Math.round(num))}`;

  public static prettyCurrencyNumbers = (numbers: number[]) =>
    `[ ${numbers.map(Utils.prettyCurrencyNumber).join(" , ")} ]`;

  public static verifyJustDigits(val: string) {
    return /^\d+$/.test(val);
  }

  public static includesIfExists(
    includedIn: StringOrNumber[],
    included: string
  ) {
    const lowerCaseIcluded = included.toLowerCase();
    return includedIn
      .map(str => str || "")
      .map(str =>
        str
          .toString()
          .toLocaleLowerCase()
          .includes(lowerCaseIcluded)
      )
      .reduce((a, b) => a || b, false);
  }

  public static objectKeyForValue(obj: any, value: any) {
    const keys = Object.keys(obj);
    for (const key of keys) {
      const keyValue = obj[key];
      if (keyValue === value) {
        return key;
      }
    }

    return undefined;
  }

  public static async copyToClipboard(toCopy: string | number) {
    const nav = navigator as any;
    if (nav && nav.clipboard && nav.clipboard.writeText) {
      await (navigator as any).clipboard.writeText(toCopy || "");
    }
  }

  public static pluralCounterString(
    count: number,
    singular: string,
    plural?: string
  ) {
    if (count === 0) {
      return "";
    } else if (count === 1) {
      return `${count} ${singular}`;
    } else if (plural) {
      return `${count} ${plural}`;
    } else {
      return `${count} ${singular}s`;
    }
  }

  public static generateInvitationLink = (uid: string, cowork: string) => {
    return `${HTTPS_PREFIX}${Config.domain()}${SHORT_SIGNUP}?${ADMIN_APPLICATION_ID_QUERY_PARAM}=${uid}&${ADMIN_COWORK_ID_QUERY_PARAMS}=${cowork}&${SHORT_SIGNUP_ANALYTICS_REFERRAL}`
  }

  public static generateConnectBankLink = (uid: string, cowork: string | undefined) => {
    let link =  `${HTTPS_PREFIX}${Config.domain()}${CONNECT_BANK}?${ADMIN_APPLICATION_ID_QUERY_PARAM}=${uid}`;
    if(cowork) {
      link += `&${ADMIN_COWORK_ID_QUERY_PARAMS}=${cowork}`
    }
    return link;
  }
}




// WEBPACK FOOTER //
// ./src/services/utils/Utils.ts